import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'
import { FinalizedReport } from '../finalizedReports'

const FINALIZED_REPORTS_QUERY_KEY = 'finalized-reports'

export const useGetFinalizedReportsForInstallation = (installationId: string) => {
  return useQuery({
    queryKey: [FINALIZED_REPORTS_QUERY_KEY, installationId],
    queryFn: async () => {
      const res = await apiClient.get<FinalizedReport[]>(
        `/v2/installations/${installationId}/finalized-reports`
      )
      return res.data
    }
  })
}
